var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage2Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.5H40M20 32.5H35M31.25 51.25L30 52.5L22.5 45H15C13.0109 45 11.1032 44.2098 9.6967 42.8033C8.29018 41.3968 7.5 39.4891 7.5 37.5V17.5C7.5 15.5109 8.29018 13.6032 9.6967 12.1967C11.1032 10.7902 13.0109 10 15 10H45C46.9891 10 48.8968 10.7902 50.3033 12.1967C51.7098 13.6032 52.5 15.5109 52.5 17.5V31.25M40 47.5H55M47.5 40V55",
    stroke: "#1E3F76",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage2Plus);
export default __webpack_public_path__ + "static/media/message-2-plus.47791105652213e1094060cdfaf9fd89.svg";
export { ForwardRef as ReactComponent };